import { Form, Rate } from "antd";
import React, { useState } from "react";
import { Rule } from "antd/es/form";
type Props = {
  onChangeRate?: (value: number) => void;
  name: string;
  rules?: Rule[] | undefined;
  defaultValue?: number | null;
};
const CommentRate = ({ onChangeRate, name, rules, defaultValue }: Props) => {
  const desc = [
    "Sản phẩm không phù hợp với tôi",
    "Không ấn tượng với sản phẩm",
    "Sản phẩm bình thường",
    "Hài lòng về sản phẩm",
    "Cực kỳ hài lòng về sản phẩm",
  ];
  const [value, setValue] = useState(defaultValue ? defaultValue : 0);

  //

  const onChange = (val: number) => {
    onChangeRate && onChangeRate(val);
    setValue(val);
  };
  return (
    <Form.Item
      name={name}
      rules={rules}
      label=""
      style={{ padding: 0, margin: 0 }}
    >
      <span
        style={{
          width: "auto",
          display: "inline-flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Rate
          allowClear={false}
          // tooltips={desc}
          onChange={onChange}
          defaultValue={defaultValue ? defaultValue : 1}
          value={value}
          style={{ color: "#D72229" }}
        />
        {/* {value ? (
          <span
            className="ant-rate-text"
            style={{ fontWeight: 700, color: "#3A393A" }}
          >
            {desc[value - 1]}
          </span>
        ) : (
          ""
        )} */}
      </span>
    </Form.Item>
  );
};

export default CommentRate;
